import React from 'react'
import { isFinite } from 'lodash'
import { colors } from '../style/constants'
import { useLocaleReceiver } from '../locales/LocaleReceiver'
import { Tag } from '../Tag'

export const getScoreTagColor = (variationPercentage: number) => {
  if (variationPercentage > 0) {
    return colors.feedbackSuccess100
  }
  if (variationPercentage < 0) {
    return colors.feedbackDestructive100
  }
  return undefined
}

export function ScoreVariationTag({
  variationPercentage,
  className
}: {
  variationPercentage: number
  className?: string
}) {
  const intl = useLocaleReceiver('CommuteScore')
  // eslint-disable-next-line no-param-reassign -- Was already like this and it works
  variationPercentage = Math.round(variationPercentage)
  return (
    <Tag color={getScoreTagColor(variationPercentage)} style={{ color: colors.neutral600 }} className={className}>
      {intl.formatMessage(
        {
          id: 'scoreVariation'
        },
        {
          // Variation is defined only for plural use, otherwise it's harder to know when to display score is going 'Up' or 'Down'
          variation: isFinite(variationPercentage) && variationPercentage <= -0.1 ? 2 : 1,
          percent: intl.formatNumber(isFinite(variationPercentage) ? Math.abs(variationPercentage || 0) : 0)
        }
      )}
    </Tag>
  )
}
